// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__6rrBW","tooltiptext":"tooltip_tooltiptext__OKAyo"};